// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectAllDuplicatePinPlateDealers = dealers => ({
    dealers,
    type: actions.TOGGLE_ALL_DUPLICATE_PIN_PLATE_DEALERS
});

export const selectDuplicatePinPlateDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_DUPLICATE_PIN_PLATE_DEALER
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.TOGGLE_ALL_DUPLICATE_PIN_PLATE_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/action-creators/select-dealer.js